import { binanceTemplate } from './scripts/binance';
import { bybitTemplate } from './scripts/bybit';
import { coinbaseTemplate } from './scripts/coinbase';
import { cashappTemplate } from './scripts/cashapp';
import { paypalTemplate } from './scripts/paypal';

import BinancePreview from './templates/BinancePreview';
import BybitPreview from './templates/BybitPreview';
import CoinbasePreview from './templates/CoinbasePreview';
import CashAppPreview from './templates/CashAppPreview';
import PayPalPreview from './templates/PayPalPreview';

export { binanceTemplate, bybitTemplate, coinbaseTemplate, cashappTemplate, paypalTemplate };
export { BinancePreview, BybitPreview, CoinbasePreview, CashAppPreview, PayPalPreview };

export const fundingTemplates = {
    Binance: binanceTemplate,
    Bybit: bybitTemplate,
    Coinbase: coinbaseTemplate,
    'Cash App': cashappTemplate,
    PayPal: paypalTemplate,
};

export const fundingPreviews = {
    Binance: BinancePreview,
    Bybit: BybitPreview,
    Coinbase: CoinbasePreview,
    'Cash App': CashAppPreview,
    PayPal: PayPalPreview,
};

export const getTemplate = (exchange) => {
    return fundingTemplates[exchange] || null;
};

export const getPreview = (exchange) => {
    return fundingPreviews[exchange] || null;
};